module.exports = __webpack_public_path__ + "img/img-idCardUpload.67652a94.png";